<h2>{{ 'DIALOG_TITLE_DELETE' | translate }}</h2>
<p>{{ 'DIALOG_TEXT_DELETE' | translate }}</p>
<div class="button-group">
  <button (click)="cancel()" mat-button style="margin-right: 16px">
    {{ 'CANCEL' | translate }}
  </button>
  <button (click)="deleteAll()" color="warn" mat-raised-button>
    {{ 'DELETE' | translate }}
  </button>
</div>
<div class="hashy-icon-wrapper">
  <cb-hashy></cb-hashy>
</div>
